import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { TableSecondary, TableRow, TableData } from 'components/layout/Table'
import { assessorActivities as assessorLayout } from 'constants/layout/assessor'

export default class AssessorParticipantTable extends Component {
  static propTypes = {
    activity: PropTypes.object
  }

  getDurationHHMM = seconds => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor(seconds / 60) - hours * 60

    return `${hours}:${minutes}`
  }

  render() {
    const { activity } = this.props

    return (
      <TableSecondary ths={assessorLayout.tableHeaders} transposable>
        <TableRow isSingleItem>
          <TableData>
            {get(activity, 'startDate') && (
              <FormattedDate value={activity.startDate} />
            )}
          </TableData>
          <TableData>
            {get(activity, 'isMajor') ? (
              <FormattedMessage id="label.yes" defaultMessage="Yes" />
            ) : (
              <FormattedMessage id="label.no" defaultMessage="No" />
            )}
          </TableData>
          <TableData>{get(activity, 'completionText')}</TableData>
          <TableData>{get(activity, 'completedPercentage')}%</TableData>
        </TableRow>
      </TableSecondary>
    )
  }
}
